var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2WalkingIssuesV4(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 11.3894V11.3894C9.76994 11.3894 9.58331 11.2027 9.58331 10.9725V10.9725C9.58331 10.8958 9.64552 10.8336 9.72226 10.8336H10.2781C10.3548 10.8336 10.417 10.8958 10.417 10.9725V10.9725C10.417 11.2027 10.2304 11.3894 10.0002 11.3894Z",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0019 10.8338C15.0019 11.2942 15.3752 11.6675 15.8356 11.6675V11.6675C16.7564 11.6675 17.5029 10.921 17.5029 10.0001V7.49909C17.5029 6.1178 16.3832 4.99805 15.0019 4.99805H14.6543",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70843 14.874L5.83203 17.5032",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.292 14.874L14.1684 17.5032",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34576 4.99805H4.99811C3.61682 4.99805 2.49707 6.1178 2.49707 7.49909V10.0001C2.49707 10.921 3.24357 11.6675 4.16443 11.6675V11.6675C4.62486 11.6675 4.99811 11.2942 4.99811 10.8338",
    stroke: "#7A7670",
    style: (_ref6 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6677 14.8597V15.419C11.6677 16.1097 11.1079 16.6695 10.4172 16.6695H9.58353C8.89289 16.6695 8.33301 16.1097 8.33301 15.419V14.8594",
    stroke: "#7A7670",
    style: (_ref7 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref7, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref7, "strokeOpacity", 1), _ref7),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 11.3897V12.5012C10.0001 13.8825 8.88038 15.0023 7.49909 15.0023V15.0023C6.1178 15.0023 4.99805 13.8825 4.99805 12.5012V6.66547C4.99805 4.36333 6.8643 2.49707 9.16645 2.49707H10.8338C13.136 2.49707 15.0022 4.36333 15.0022 6.66547V12.5012C15.0022 13.8825 13.8825 15.0023 12.5012 15.0023V15.0023C11.1199 15.0023 10.0001 13.8825 10.0001 12.5012V11.3897Z",
    stroke: "#7A7670",
    style: (_ref8 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref8, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref8, "strokeOpacity", 1), _ref8),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8762 7.91613C11.8761 8.03117 11.7828 8.12433 11.6677 8.12428C11.5527 8.12423 11.4594 8.03099 11.4594 7.91595C11.4593 7.80091 11.5525 7.70759 11.6675 7.70744C11.7229 7.70737 11.776 7.72934 11.8152 7.76849C11.8543 7.80764 11.8763 7.86076 11.8762 7.91613",
    stroke: "#7A7670",
    style: (_ref9 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref9, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref9, "strokeOpacity", 1), _ref9),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54128 7.91613C8.54113 8.03117 8.4478 8.12433 8.33277 8.12428C8.21773 8.12423 8.12448 8.03099 8.12444 7.91595C8.12439 7.80091 8.21755 7.70759 8.33259 7.70744C8.38796 7.70737 8.44108 7.72934 8.48023 7.76849C8.51938 7.80764 8.54135 7.86076 8.54128 7.91613",
    stroke: "#7A7670",
    style: (_ref10 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref10, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref10, "strokeOpacity", 1), _ref10),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2WalkingIssuesV4);
export default __webpack_public_path__ + "static/media/customV2WalkingIssuesV4.fe277f1e7a3985f81838b3a4fadf3a8e.svg";
export { ForwardRef as ReactComponent };